import { Theme } from '@mui/material';

const Switch = (theme: Theme) => {
  return {
  };
};

export default Switch;
